<template>
    <div>
        <div id="collage">
            <h2 v-html="task.question"></h2>
            <hr />
            <div
                id="playPanel"
                style="display:none;"
            >
                <div
                    class="d-flex justify-content-center flex-row position-relative"
                >
                    <ul
                        id="sortable"
                        class="sortable mx-auto"
                        :class="{'success': form.status === true}"
                        :style="`width:604px`"
                    ></ul>
                    <div
                        v-if="form.status === true"
                        class="position-absolute" style="right: 0;"
                    >
                        <svg class="text-success" style="width: 60px; height: 60px;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </div>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-12 text-right">
                    <span class="badge badge-pill badge-success p-3">
                        Lépések száma: {{  form.steps }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        task: {
            type: Object,
            required: true,
        },
        value: {
            type: Object,
            required: true,
        },
    },
    watch: {
        form: {
            deep: true,
            handler() {
                this.$emit('input', this.form);
            }
        },
    },
    data() {
        return {
            form: {
                task_id: this.task.id,
                status: false,
                steps: 0,
                time: 0,
            },
            images: [{
                src: this.task.taskable.puzzle_image,
                title: 'RHK',
            }],
            startTime: new Date().getTime(),
        };
    },
    mounted() {
        this.startGame(this.images, (this.task.taskable.slice_number / 2));

        this.$emit('input', this.form);
    },
    methods: {
        restart() {
            this.startGame(images, (this.task.taskable.slice_number / 2));
        },
        startGame: function (images, gridSize) {
            this.setImage(images, gridSize);
            this.doc('playPanel').style.display = 'block';
            this.shuffle('sortable');
            this.form.steps = 0;
            this.startTime = new Date().getTime();
        },
        setImage: function (images, gridSize = 4) {
            var percentage = 100 / (gridSize - 1);
            var image = images[Math.floor(Math.random() * images.length)];

            this.doc('imgTitle').innerHTML = image.title;
            this.doc('actualImage').setAttribute('src', image.src);
            this.doc('sortable').innerHTML = '';
            for (var i = 0; i < gridSize * gridSize; i++) {
                var xpos = (percentage * (i % gridSize)) + '%';
                var ypos = (percentage * Math.floor(i / gridSize)) + '%';
                let li = document.createElement('li');
                li.id = i;
                li.setAttribute('data-value', i);
                li.style.backgroundImage = 'url(' + image.src + ')';
                li.style.backgroundSize = (gridSize * 100) + '%';
                li.style.backgroundPosition = xpos + ' ' + ypos;
                li.style.width = 600 / gridSize + 'px';
                li.style.height = 600 / gridSize + 'px';

                li.setAttribute('draggable', 'true');
                li.ondragstart = (event) => event.dataTransfer.setData('data', event.target.id);
                li.ondragover = (event) => event.preventDefault();
                li.ondrop = (event) => {
                    let origin = this.doc(event.dataTransfer.getData('data'));
                    let dest = this.doc(event.target.id);
                    let p = dest.parentNode;

                    if (origin && dest && p) {
                        let temp = dest.nextSibling;
                        let x_diff = origin.offsetLeft-dest.offsetLeft;
                        let y_diff = origin.offsetTop-dest.offsetTop;

                        if(y_diff == 0 && x_diff >0){
                            //LEFT SWAP
                            p.insertBefore(origin, dest);
                            p.insertBefore(temp, origin);
                        }
                        else{
                            p.insertBefore(dest, origin);
                            p.insertBefore(origin, temp);
                        }


                        let vals = Array.from(this.doc('sortable').children).map(x => x.id);
                        var now = new Date().getTime();
                        ++this.form.steps;
                        this.form.time = (parseInt((now - this.startTime) / 1000, 10));

                        if (this.isSorted(vals)) {
                            // helper.doc('actualImageBox').style.display = 'none';
                            // helper.doc('gameOver').style.display = 'block';
                            this.form.status = true;
                        }
                    }
                };
                li.setAttribute('dragstart', 'true');
                this.doc('sortable').appendChild(li);
            }
            this.shuffle('sortable');
        },
        doc: (id) => {
            return document.getElementById(id) || document.createElement("div")
        },
        shuffle: (id) => {
            var ul = document.getElementById(id);
            for (var i = ul.children.length; i >= 0; i--) {
                ul.appendChild(ul.children[Math.random() * i | 0]);
            }
        },
        isSorted: (array) => {
            return array.every((elem, index) => { return elem == index; });
        }
    }
}
</script>
<style>
#collage hr{
    border:none;
    border-top:2px solid #f5f2f2;
    height:1px;
}

#collage #playPanel {
    padding:10px 0px;
    margin: 10px auto;
    max-width:800px;
    width:95%;
}

#collage #stepBox, #collage #timeBox {
    display:inline-block;
    width:48%;
}

#collage #stepBox div {
    background-color:#c2defc;
    display:inline-block;
    padding:1px 4px;
    margin: 0px auto;
    max-width:800px;
}

#collage img#actualImage{
    border:2px solid #a46;
    height:280px;
    width:280px;
}

#collage #sortable {
    border:2px solid #a46;
    list-style-type: none;
    display: inline-block;
    margin: 10px;
    padding: 0;
}

#collage #sortable li {
    background-size: 600% 600%;
    border: none;
    cursor: pointer;
    margin: 0;
    padding: 0;
    float: left;
    width: 100px;
    height: 100px;
}

#collage button  {
    background-color:#f5f2f2;
    border:1px solid #cce;
    display: inline;
    font-size: 14px;
    height: auto;
    width: auto;
    padding: 3px 8px;
}
.success {
    border: 2px solid rgba(0, 128, 0, 0.99) !important;
    background-color: rgba(0, 128, 0, 0.1);
    backdrop-filter: blur(2px);
    pointer-events: none;
}
</style>
